// hbsfy compiled Handlebars template
var HandlebarsCompiler = require('hbsfy/runtime');
module.exports = HandlebarsCompiler.template({"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + container.escapeExpression((lookupProperty(helpers,"staticImage")||(depth0 && lookupProperty(depth0,"staticImage"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"logo-light",{"name":"staticImage","hash":{},"data":data,"loc":{"start":{"line":4,"column":10},"end":{"line":4,"column":38}}}));
},"3":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "          "
    + container.escapeExpression((lookupProperty(helpers,"staticImage")||(depth0 && lookupProperty(depth0,"staticImage"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"logo-dark",{"name":"staticImage","hash":{},"data":data,"loc":{"start":{"line":6,"column":10},"end":{"line":6,"column":37}}}));
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<header class=\"brec-authentication__header\">\n  <img src=\""
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"view") : depth0)) != null ? lookupProperty(stack1,"isPatient") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":3,"column":8},"end":{"line":7,"column":16}}})) != null ? stack1 : "")
    + "\"\n      alt=\""
    + container.escapeExpression((lookupProperty(helpers,"i18n")||(depth0 && lookupProperty(depth0,"i18n"))||container.hooks.helperMissing).call(alias1,"hospital.name",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":8,"column":11},"end":{"line":8,"column":35}}}))
    + "\"\n      data-test-header-logo\n  />\n</header>\n<main inject=\"main\"></main>\n<footer inject=\"footer\"></footer>\n";
},"useData":true});
